/**
 * Common insurance payers used in behavioral health / mental health billing.
 * Each entry: { name, ediId }
 * EDI IDs are Stedi/Change Healthcare trading partner IDs.
 */
const PAYERS = [
  // National commercial payers
  { name: 'Aetna', ediId: '60054' },
  { name: 'Aetna Better Health (Medicaid)', ediId: '60054' },
  { name: 'Anthem Blue Cross Blue Shield', ediId: 'ANTBC' },
  { name: 'Blue Cross Blue Shield Federal Employee Program', ediId: '00050' },
  { name: 'BCBS Alabama', ediId: '00510' },
  { name: 'BCBS Arizona', ediId: '86047' },
  { name: 'BCBS California (Anthem)', ediId: 'CALI0' },
  { name: 'BCBS Florida (Florida Blue)', ediId: '00590' },
  { name: 'BCBS Georgia', ediId: '00611' },
  { name: 'BCBS Illinois', ediId: '00620' },
  { name: 'BCBS Kansas City', ediId: '00630' },
  { name: 'BCBS Louisiana', ediId: '00640' },
  { name: 'BCBS Massachusetts', ediId: '00660' },
  { name: 'BCBS Michigan', ediId: '00670' },
  { name: 'BCBS Minnesota', ediId: 'MHPAE' },
  { name: 'BCBS Mississippi', ediId: '00690' },
  { name: 'BCBS Montana', ediId: '00700' },
  { name: 'BCBS Nebraska', ediId: '00710' },
  { name: 'BCBS New Mexico', ediId: '00720' },
  { name: 'BCBS North Carolina', ediId: '00730' },
  { name: 'BCBS North Dakota', ediId: '00740' },
  { name: 'BCBS Oklahoma', ediId: '00760' },
  { name: 'BCBS South Carolina', ediId: '00780' },
  { name: 'BCBS South Dakota', ediId: '00790' },
  { name: 'BCBS Tennessee', ediId: '00800' },
  { name: 'BCBS Texas', ediId: '00901' },
  { name: 'BCBS Vermont', ediId: '00830' },
  { name: 'BCBS Western New York', ediId: '55204' },
  { name: 'Cigna', ediId: '62308' },
  { name: 'Cigna Behavioral Health', ediId: '62308' },
  { name: 'Humana', ediId: '61101' },
  { name: 'Humana Behavioral Health', ediId: '61101' },
  { name: 'Kaiser Permanente (Mid-Atlantic)', ediId: '91617' },
  { name: 'Kaiser Permanente (Northern CA)', ediId: '94135' },
  { name: 'Kaiser Permanente (Southern CA)', ediId: '91617' },
  { name: 'Magellan Health Services', ediId: '39026' },
  { name: 'Molina Healthcare', ediId: 'MOLIN' },
  { name: 'Oscar Health', ediId: 'OSCAR' },
  { name: 'Optum (United Behavioral Health)', ediId: '87726' },
  { name: 'United Healthcare', ediId: '87726' },
  { name: 'United Healthcare Community Plan', ediId: '87726' },
  { name: 'UnitedHealth Group', ediId: '87726' },

  // Government payers
  { name: 'Medicare (Part B)', ediId: 'MCARE' },
  { name: 'Medicare Advantage', ediId: 'MCARE' },
  { name: 'Medicaid (state — enter state code)', ediId: 'MDCD' },
  { name: 'Tricare / Defense Health Agency', ediId: 'HPOC' },
  { name: 'Veterans Affairs (VA/Optum)', ediId: 'VAOPT' },
  { name: 'Champva', ediId: 'CHMPVA' },

  // Managed behavioral health organizations (MBHOs)
  { name: 'Beacon Health Options', ediId: 'BXRMO' },
  { name: 'Behavioral Health Systems (BHS)', ediId: '11150' },
  { name: 'ComPsych', ediId: 'COMPSY' },
  { name: 'EAP / Employee Assistance Program', ediId: '' },
  { name: 'Evernorth Behavioral Health (Cigna)', ediId: '62308' },
  { name: 'MultiPlan / PHCS', ediId: '66001' },
  { name: 'New Directions Behavioral Health', ediId: 'NDBH' },
  { name: 'Optum EAP', ediId: '39026' },
  { name: 'Spring Health', ediId: '' },
  { name: 'Lyra Health', ediId: '' },
  { name: 'Headspace Health', ediId: '' },

  // Regional / state-specific
  { name: 'Centene / WellCare', ediId: 'WELCA' },
  { name: 'CareFirst BlueCross BlueShield (DC/MD/VA)', ediId: '00580' },
  { name: 'Capital BlueCross (PA)', ediId: '00550' },
  { name: 'EmblemHealth (NY)', ediId: 'EMBLEM' },
  { name: 'Excellus BlueCross BlueShield (NY)', ediId: '55204' },
  { name: 'Fidelis Care (NY Medicaid)', ediId: 'FIDEL' },
  { name: 'Harvard Pilgrim Health Care', ediId: 'HARVD' },
  { name: 'HealthPartners (MN)', ediId: 'HLTHP' },
  { name: 'Independence Blue Cross (PA)', ediId: '00590' },
  { name: 'LA Care Health Plan', ediId: 'LACAR' },
  { name: 'Medica', ediId: 'MEDIC' },
  { name: 'Meridian Health Plan', ediId: 'MRDHN' },
  { name: 'MVP Health Care (NY/VT)', ediId: 'MVPHC' },
  { name: 'Premera Blue Cross (WA/AK)', ediId: '00559' },
  { name: 'Priority Health (MI)', ediId: 'PRIOH' },
  { name: 'Regence BlueCross BlueShield', ediId: '00590' },
  { name: 'SelectHealth (UT)', ediId: 'SELEC' },
  { name: 'Sunshine Health (FL Medicaid)', ediId: 'SUNSH' },
  { name: 'UPMC Health Plan', ediId: 'UPMCM' },
];

export default PAYERS;
